import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import InvoiceAddLayer from "../components/InvoiceAddLayer";
import ProformaInvoiceAddLayer from "../components/ProformaInvoiceAddLayer";
import QuotationAddLayer from "../components/QuotationAddLayer";




const QuotationAddPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* InvoiceAddLayer */}
        <QuotationAddLayer />

      </MasterLayout>

    </>
  );
};

export default QuotationAddPage;
